import { useState, useEffect, useContext } from 'react';
import { Drawer, Select, Button, Space, message, Spin, Form } from 'antd';
import axios from 'axios';
import { LoginContext } from '../../context/loginContext';

const LocalidadesDrawer = ({
  open,
  onClose,
  onSelectLocation,
  initialLocationId = null,
  title = "Seleccionar Localidad"
}) => {
  const [form] = Form.useForm();
  const [provincias, setProvincias] = useState([]);
  const [filteredCiudades, setFilteredCiudades] = useState([]); // Initialize as empty array
  const [selectedProvinciaId, setSelectedProvinciaId] = useState(null);
  const [selectedCiudadId, setSelectedCiudadId] = useState(null);
  const [selectedCiudadNombre, setSelectedCiudadNombre] = useState('');
  const [loading, setLoading] = useState(true);
  const { user } = useContext(LoginContext);

  const apiUrl = process.env.REACT_APP_API_URL;
  const config = { headers: { Authorization: `Bearer ${user.token}` } };

  useEffect(() => {
    const fetchProvincias = async () => {
      try {
        setLoading(true);
        const provinciasResponse = await axios.get(`${apiUrl}/localidad/provincias`, config);
        setProvincias(Array.isArray(provinciasResponse.data) ? provinciasResponse.data : []);
      } catch (error) {
        message.error('Error al cargar provincias');
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    if (open) {
      fetchProvincias();

      // Resetear estados al abrir
      form.resetFields();
      setSelectedProvinciaId(null);
      setSelectedCiudadId(null);
      setSelectedCiudadNombre('');
      setFilteredCiudades([]);
    }
  }, [open]);

  // Cargar ciudades cuando se selecciona una provincia
  const handleProvinciaChange = async (provinciaId) => {
    try {
      setSelectedProvinciaId(provinciaId);
      setSelectedCiudadId(null);
      setSelectedCiudadNombre('');
      form.setFieldsValue({ localidad: undefined });
      setLoading(true);

      const response = await axios.get(`${apiUrl}/localidad/localidades/${provinciaId}`, config);
      // Ensure we're setting an array
      const ciudades = Array.isArray(response.data) ? response.data : [];
      setFilteredCiudades(ciudades);
    } catch (error) {
      message.error('Error al cargar localidades');
      console.error(error);
      setFilteredCiudades([]); // Set to empty array on error
    } finally {
      setLoading(false);
    }
  };

const handleCiudadChange = (ciudadId) => {
  setSelectedCiudadId(ciudadId);
  const ciudadSeleccionada = filteredCiudades.find(ciudad => ciudad.loc_id === ciudadId);
  if (ciudadSeleccionada) {
    setSelectedCiudadNombre(ciudadSeleccionada.loc_nombre);
    form.setFieldsValue({ localidad: ciudadSeleccionada.loc_id });
  }
};


  const handleConfirm = () => {
    if (selectedCiudadId) {
      onSelectLocation({
        id: selectedCiudadId,
        nombre: selectedCiudadNombre
      });
      onClose();
    } else {
      message.warning('Por favor seleccione una localidad');
    }
  };

  return (
    <Drawer
      title={title}
      placement="right"
      onClose={onClose}
      open={open}
      width={320}
      footer={
        <div style={{ textAlign: 'right' }}>
          <Space>
            <Button onClick={onClose}>Cancelar</Button>
            <Button type="primary" onClick={handleConfirm} disabled={!selectedCiudadId}>
              Aceptar
            </Button>
          </Space>
        </div>
      }
    >
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '250px' }}>
          <Spin size="large" />
        </div>
      ) : (
        <Form form={form} layout="vertical">
          <Form.Item
            label="Provincia"
            name="provincia"
            rules={[{ required: true, message: 'Por favor seleccione una provincia' }]}
          >
            <Select
              placeholder="Seleccione una provincia"
              style={{ width: '100%' }}
              value={selectedProvinciaId}
              onChange={handleProvinciaChange}
              options={provincias.map((provincia) => ({
                value: provincia.pro_id,
                label: provincia.pro_nombre,
              }))}
            />
          </Form.Item>

          <Form.Item
            label="Localidad"
            name="localidad"
            rules={[{ required: true, message: 'Por favor seleccione una localidad' }]}
          >
            <Select
              placeholder="Seleccione una localidad"
              style={{ width: '100%' }}
              disabled={!selectedProvinciaId}
              value={selectedCiudadId}
              onChange={handleCiudadChange}
              options={Array.isArray(filteredCiudades) ? filteredCiudades.map((ciudad) => ({
                value: ciudad.loc_id,
                label: ciudad.loc_nombre,
              })) : []}
            />
          </Form.Item>
        </Form>
      )}
    </Drawer>
  );
};

export default LocalidadesDrawer;